// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":root{--light_text_color:#666}.productpage__posting b{border-bottom:2px solid #323236;display:inline-block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
